import { FC } from 'react';
import { useSelector } from 'react-redux';
import { foldersModel } from '../../../features/folders';

import { SearchType } from '../config';
import { SearchModalVideoRecords } from './SearchModalVideoRecords';
import { SearchModalCallRecords } from './SearchModalCallRecords';
import { SearchModalTemplates } from './SearchModalTemplates';
import { SearchModalSnippets } from './SearchModalSnippets';
import { SearchModalPages } from './SearchModalPages';

type Props = {
  onClear: () => void;
  onClose: () => void;
  searchType: SearchType;
  search: string;
};

export const SearchModalContent: FC<Props> = ({
  search,
  searchType,
  onClear,
  onClose,
}) => {
  const currentFolder = useSelector(foldersModel.selectors.selectCurrentFolder);

  return (
    <div className="-mb-6 pb-12 mr-5 flex-grow-1 overflow-y-auto relative">
      {searchType === 'folder' && (
        <SearchModalPages
          folderId={currentFolder?.id ?? ''}
          search={search}
          onClear={onClear}
        />
      )}
      {searchType === 'all-pages' && (
        <SearchModalPages search={search} onClear={onClear} />
      )}
      {searchType === 'videoRecord' && (
        <SearchModalVideoRecords search={search} onClear={onClear} />
      )}
      {searchType === 'callRecord' && (
        <SearchModalCallRecords search={search} onClear={onClear} />
      )}
      {searchType === 'template' && (
        <SearchModalTemplates
          search={search}
          onClear={onClear}
          onClose={onClose}
        />
      )}
      {searchType === 'snippet' && (
        <SearchModalSnippets
          search={search}
          onClear={onClear}
          onClose={onClose}
        />
      )}
    </div>
  );
};
